import { Option } from 'types'

export const CUSTOM_FORM_DOCUMENTS_OPTIONS: Option[] = [
  {
    label: 'CPF',
    value: 'CPF',
  },
  {
    label: 'CTPS',
    value: 'CTPS',
  },
  {
    label: 'PIS',
    value: 'PIS',
  },
]
